import {DomainObject} from 'shared/store';
import {observable, computed} from 'mobx';

class CoverageVolumeReduction extends DomainObject {
  @observable reductionType;
  @observable age;
  @observable percentage;
  @observable amount;

  @computed get isAmount() {
    return this.reductionType === 'amount';
  }

  @computed get isPercentage() {
    return this.reductionType === 'percentage';
  }
}

export default CoverageVolumeReduction;
